import { useMemo } from 'react';
import Log from '@deephaven/log';
import usePlugins from "./usePlugins.js";
import { isWidgetPlugin, isWidgetMiddlewarePlugin } from "./PluginTypes.js";
import { createChainedComponent } from "./PluginUtils.js";
import { jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('@deephaven/plugin.WidgetView');
export function WidgetView(_ref) {
  var fetch = _ref.fetch,
    type = _ref.type;
  var plugins = usePlugins();
  var _useMemo = useMemo(() => {
      var foundBasePlugin;
      var foundMiddleware = [];
      plugins.forEach(p => {
        if (!isWidgetPlugin(p) && !isWidgetMiddlewarePlugin(p)) {
          return;
        }
        var supportsType = [p.supportedTypes].flat().includes(type);
        if (!supportsType) {
          return;
        }
        if (isWidgetMiddlewarePlugin(p)) {
          foundMiddleware.push(p);
        } else {
          if (foundBasePlugin != null) {
            log.warn("Multiple base plugins for type ".concat(type, ". Replacing ").concat(foundBasePlugin.name, " with ").concat(p.name));
          }
          foundBasePlugin = p;
        }
      });
      return {
        basePlugin: foundBasePlugin,
        middleware: foundMiddleware
      };
    }, [plugins, type]),
    basePlugin = _useMemo.basePlugin,
    middleware = _useMemo.middleware;
  var ChainedComponent = useMemo(() => {
    if (basePlugin == null) {
      log.debug("No base plugin found for widget type ".concat(type));
      return null;
    }
    return createChainedComponent(basePlugin.component, middleware);
  }, [basePlugin, middleware, type]);
  if (ChainedComponent != null) {
    return /*#__PURE__*/_jsx(ChainedComponent, {
      fetch: fetch
    });
  }
  throw new Error("Unknown widget type '".concat(type, "'"));
}
export default WidgetView;
//# sourceMappingURL=WidgetView.js.map